import { render, staticRenderFns } from "./addGoodsToPurOrder.vue?vue&type=template&id=19c8c2ff&scoped=true&"
import script from "./addGoodsToPurOrder.vue?vue&type=script&lang=js&"
export * from "./addGoodsToPurOrder.vue?vue&type=script&lang=js&"
import style0 from "./addGoodsToPurOrder.vue?vue&type=style&index=0&id=19c8c2ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c8c2ff",
  null
  
)

component.options.__file = "addGoodsToPurOrder.vue"
export default component.exports